import { CardGrid, StatTile as UiStatTile } from '@developerz/ui';
import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { orgHref } from '../lib/org';
import type { StatTile, StatTileId } from '../lib/overview-tiles';

// Home metric strip (canvas APP artboard): the shared `CardGrid` (4 columns,
// hairline gaps — the grid lines ARE the dividers) of shared `StatTile`s, the
// same two primitives marketing's stat strip renders at a different padding.
// Presenter only: `statTiles` (lib/overview-tiles) resolves every value, sub
// and tone to display strings ("—" until its source loads or when refused).
// No glyphs: the canvas strip is label + number, and the tone dot is the only
// mark a tile carries.

/** Each tile drills into the surface its number is drawn from. */
const HREFS: Record<StatTileId, () => string> = {
  merged: () => orgHref('/repos'),
  open_prs: () => orgHref('/repos'),
  boxes: () => orgHref('/fleet'),
  burn: () => orgHref('/account/billing'),
};

export function StatBand(props: { tiles: readonly StatTile[] }): JSX.Element {
  return (
    <CardGrid columns={4} as="ul" label={t('overview.aria')}>
      <For each={props.tiles}>
        {(tile) => (
          <UiStatTile
            label={tile.label}
            value={tile.value}
            {...(tile.sub === undefined ? {} : { sub: tile.sub })}
            tone={tile.tone}
            href={HREFS[tile.id]()}
          />
        )}
      </For>
    </CardGrid>
  );
}
